<div class="container-fluid">
    <div class="modal-header">
        <h4 *ngIf="modalMode === 'Add'">Add {{ headingName }} Document</h4>
        <h4 *ngIf="modalMode === 'Update'">Update Document</h4>
        <h4 *ngIf="modalMode === 'Edit'">Edit Document</h4>
        <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modalService.close(false)">
            <i class="flaticon2-cross"></i>
        </a>
    </div>
    <div class="modal-body output-lable" [formGroup]="documentUploadForm">
        <div class="row hero-image-card">
            <div class="col-md-12">
                <div class="card card-custom gutter-b card-stretch">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3" style="padding: 15px">
                                <mat-label class="font-style">Document Title</mat-label>
                            </div>
                            <div class="col-md-9">
                                <input
                                    type="text"
                                    class="input-form-class"
                                    matInput
                                    name="documentTitle"
                                    placeholder="Enter Document Name"
                                    formControlName="documentTitle"
                                    [ngClass]="{
                                        highLight: documentUploadForm.get('documentTitle')?.invalid,
                                    }"
                                    (keypress)="onKeyPress($event)"
                                    (paste)="onKeyPress($event)"
                                />
                                <ng-container *ngIf="documentUploadForm.get('documentTitle')?.invalid && documentUploadForm.get('documentTitle')?.dirty">
                                    <p class="error-message" *ngIf="documentUploadForm.get('documentTitle')?.errors?.maxlength">
                                        Document Name length should be maximum 255 character.
                                    </p>
                                    <p class="error-message" *ngIf="documentUploadForm.get('documentTitle')?.errors?.required">
                                        Document Name should be required.
                                    </p>
                                </ng-container>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3" style="padding: 15px">
                                <mat-label class="font-style">Document No</mat-label>
                            </div>
                            <div class="col-md-9">
                                <input
                                    type="text"
                                    class="input-form-class"
                                    matInput
                                    name="documentNo"
                                    placeholder="Enter Document No"
                                    formControlName="documentNo"
                                    [ngClass]="{
                                        highLight: documentUploadForm.get('documentNo')?.invalid,
                                    }"
                                    (keypress)="onKeyPress($event)"
                                    (paste)="onKeyPress($event)"
                                />
                                <ng-container *ngIf="documentUploadForm.get('documentNo')?.invalid && documentUploadForm.get('documentNo')?.dirty">
                                    <p class="error-message" *ngIf="documentUploadForm.get('documentNo')?.errors?.maxlength">
                                        Document No length should be maximum 255 character.
                                    </p>
                                    <p class="error-message" *ngIf="documentUploadForm.get('documentNo')?.errors?.required">Document No should be required.</p>
                                </ng-container>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3" style="padding: 15px">
                                <mat-label class="font-style">Document Revision</mat-label>
                            </div>
                            <div class="col-md-9">
                                <input
                                    type="text"
                                    class="input-form-class"
                                    matInput
                                    name="documentRevision"
                                    placeholder="Enter Document Revision"
                                    formControlName="documentRevision"
                                    [ngClass]="{
                                        highLight: documentUploadForm.get('documentRevision')?.invalid,
                                    }"
                                    (keypress)="onKeyPress($event)"
                                    (paste)="onKeyPress($event)"
                                />
                                <ng-container *ngIf="documentUploadForm.get('documentRevision')?.invalid && documentUploadForm.get('documentRevision')?.dirty">
                                    <p class="error-message" *ngIf="documentUploadForm.get('documentRevision')?.errors?.maxlength">
                                        Document Revision length should be maximum 255 character.
                                    </p>
                                    <p class="error-message" *ngIf="documentUploadForm.get('documentRevision')?.errors?.required">
                                        Document Revision should be required.
                                    </p>
                                </ng-container>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3" style="padding: 15px">
                                <mat-label class="font-style">Document Comments</mat-label>
                            </div>
                            <div class="col-md-9">
                                <input
                                    type="text"
                                    class="input-form-class"
                                    matInput
                                    name="documentComments"
                                    placeholder="Enter Document Comments"
                                    formControlName="documentComments"
                                    (keypress)="onKeyPress($event)"
                                    (paste)="onKeyPress($event)"
                                />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-3"></div>
                            <div class="col-md-9">
                                <ng-container>
                                    <div class="upload_file">
                                        <div class="image-upload" *ngIf="!uploadedFile">
                                            <button class="upload-btn" *ngIf="Type == 'Document'">
                                                <input class="upload-input" type="file" accept="application/pdf" (change)="fileChangeEvent($event)" /><i
                                                    class="pi pi-upload"
                                                ></i>
                                            </button>
                                            <button class="upload-btn" *ngIf="!Type">
                                                <input
                                                    class="upload-input"
                                                    type="file"
                                                    [accept]="Type == 'Document' ? '.pdf' : '.pdf, image/*, .xls, .xlsx'"
                                                    (change)="fileChangeEvent($event)"
                                                /><i class="pi pi-upload"></i>
                                            </button>
                                            <div class="image-details">
                                                <div class="file-name">Add File</div>
                                                <div class="img-info" *ngIf="Type == 'Document'">PDF</div>
                                                <div class="img-info" *ngIf="!Type">PDF, IMAGES,xls,xlsx</div>
                                            </div>
                                        </div>
                                        <ul *ngIf="uploadedFile">
                                            <li>
                                                <div class="fileData" style="position: relative; top: 5px; display: -webkit-inline-box">
                                                    <img
                                                        src="./assets/media/logos/technical-drawing.png"
                                                        alt="isometric-logo"
                                                        style="width: 21px; height: auto; position: relative; top: -5px"
                                                    />
                                                    <p class="ellipsis">{{ uploadedFile.name }}</p>
                                                    <p>{{ (uploadedFile.size / 1024).toFixed(2) }} KB</p>
                                                    <div
                                                        class="image-upload"
                                                        style="
                                                            display: block;
                                                            padding: 0px;
                                                            position: relative;
                                                            border: none !important;
                                                            top: -3px;
                                                            width: 50px;
                                                        "
                                                    >
                                                        <button
                                                            class="upload-btn"
                                                            style="width: 25px; height: 25px; border-radius: 5px"
                                                            #tooltip="matTooltip"
                                                            matTooltip="Replace drawing"
                                                            [matTooltipPosition]="tooltip_position"
                                                        >
                                                            <input class="upload-input" type="file" (change)="fileChangeEvent($event)" /><i
                                                                class="pi pi-upload"
                                                                style="font-size: 13px; color: #fff"
                                                            ></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                <!-- <div class="closeBtn" (click)="removeUploadedFile()"><i
                                                        class="flaticon2-cross"></i></div> -->
                                            </li>
                                        </ul>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="row mt-3" *ngIf="linkEntityType === LinkEntityType.TaggedItem && Type == 'Document'">
                            <div class="col-md-3"></div>
                            <div class="col-md-9">
                                <ng-container>
                                    <mat-checkbox
                                        class="checkbox-wrap"
                                        formControlName="AllowChildrenInherit"
                                        name="AllowChildrenInherit"
                                        [checked]="allowChildrenInherit"
                                        [id]="AllowChildrenInherit"
                                        (change)="updateAllowChildrenInherit($event)"
                                        >Enable Dynamic Allocation</mat-checkbox
                                    >
                                </ng-container>
                            </div>
                        </div>

                        <div class="row mt-3" *ngIf="!allowChildrenInherit">
                            <div class="col-md-12" style="color: red">
                                Disabling dynamic allocation will remove dynamic links and maintain existing static links, limiting it's capacity for
                                dynamically allocating future children.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn secondary-ebtn" (click)="modalService.close(false)">Cancel</button>
        <button type="button" class="btn primary-ebtn" (click)="btnAddClicked()" [disabled]="!(documentUploadForm.valid && documentUploadForm.dirty)">
            {{ modalMode === 'Add' ? 'Add Document' : 'Save' }}
        </button>
    </div>
</div>
